import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=45e75e0a"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports